import { render, staticRenderFns } from "./TipoCanalCombobox.vue?vue&type=template&id=9c46b734&scoped=true"
import script from "./TipoCanalCombobox.vue?vue&type=script&lang=js"
export * from "./TipoCanalCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46b734",
  null
  
)

export default component.exports